<fui-action *ngIf="showRefresh" (click)="refresh.next($event)" [attr.title]="'wbo.common.button.refresh' | translate">
    <fui-icon [icon]="'refresh'" [height]="20" [width]="20" class="refresh-icon"></fui-icon>
</fui-action>

<div *ngIf="rowsTruncated || columnsTruncated || restrictions" class="meta-data">
    <div *ngIf="restrictions" class="meta-data-date-range">
        <div *ngIf="!restrictions.datesRestricted" class="meta-data-date-range-displayed">
            {{"wbo.bi.message.dateRange.displayed" | translate}}
        </div>
        <div *ngIf="restrictions.datesRestricted" class="meta-data-date-range-restricted">
            {{"wbo.bi.message.dateRange.restricted" | translate}}
        </div>
        <div *ngIf="restrictions.validFilteredDates && restrictions.filteredStartDate && restrictions.filteredEndDate" class="meta-data-date-range-dates">
            {{"wbo.bi.message.dateRange.dates" | translate: {fromDate: fromDate | wbo_date, toDate: toDate | wbo_date} }}
        </div>
        <div *ngIf="restrictions.validFilteredDates && !(restrictions.filteredStartDate && restrictions.filteredEndDate)" class="meta-data-date-range-dates">
            {{"wbo.bi.message.dateRange.unlimited" | translate}}
        </div>
        <div *ngIf="!restrictions.validFilteredDates" class="meta-data-date-range-dates">
            {{"wbo.bi.message.dateRange.unavailable" | translate}}
        </div>
    </div>

    <div *ngIf="rowsTruncated || columnsTruncated" class="meta-data-truncations">
        <div *ngIf="rowsTruncated" class="meta-data-truncations-rows">
            {{"wbo.bi.message.rowsTruncated" | translate: {rows: rowsTruncated} }}
        </div>
        <div *ngIf="columnsTruncated" class="meta-data-truncations-rows">
            {{"wbo.bi.message.columnsTruncated" | translate: {columns: columnsTruncated} }}
        </div>
    </div>
</div>
